/**
 * Redirects legacy WordPress page-ID links (`/?page_id=NNNN`) to their current product routes.
 * Azure Static Web Apps route rules match on path only, so query-string redirects for these
 * legacy admin-style links cannot be expressed in `staticwebapp.config.json` — this client-side
 * redirect is the only mechanism available on a static (SSG) site for query-based legacy URLs.
 */

const LEGACY_PAGE_ID_REDIRECTS: Record<string, string> = {
  '1394': '/product/sharepoint-governance',
  '1401': '/product/regulatory-compliance',
};

export default defineNuxtRouteMiddleware((to) => {
  if (to.path !== '/') return;

  const pageId = to.query.page_id;
  if (typeof pageId !== 'string') return;

  const target = LEGACY_PAGE_ID_REDIRECTS[pageId];
  if (!target) return;

  return navigateTo(target, { replace: true });
});
